import { Component, OnInit } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Platform, Events } from '@ionic/angular';
import { environment } from '../../../environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AccountService } from 'src/app/services/auth/account.service';
import { version } from '../../../../package.json';
import { LOGO_PATH_FULL, PROFILE_TYPE } from 'src/app/constants';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Profile } from 'src/app/models/profile';
const { APP_NAME } = environment;

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss']
})
export class HomePage implements OnInit {

  version = version;
  appName = APP_NAME;
  loggedIn = false;

  logoPath = LOGO_PATH_FULL;
  profileType: PROFILE_TYPE;
  activatedRoutePath: string;

  constructor(
    platform: Platform,
    appVersion: AppVersion,
    events: Events,
    private auth: AuthService,
    private account: AccountService,
    private profileService: ProfileService,
    private activatedRoute: ActivatedRoute,
  ) {

    if (platform.is('cordova')) {
      platform.ready()
        .then(() => appVersion.getVersionNumber())
        .then(version => this.version = version)
        .catch(err => console.log('Error in version number', err));
    }
    events.subscribe('loggedIn', () => this.ngOnInit());
  }

  async ngOnInit() {
    this.activatedRoute.url.subscribe(([url]) => {
      const { path = '' } = url || {};
      this.activatedRoutePath = path;
    });

    this.profileService.profile$.subscribe((p) => {
      const { type = '' } = p || {};
      if (type) {
        this.profileType = type;
      }
    })
    this.loggedIn = await this.auth.isLoggedIn();
  }

  async enter() {
    await this.account.loginMultiplexer();
  }

  async signup() {
    await this.account.loginMultiplexer('signup');
  }

}
